import { format } from 'date-fns';

import { DatePickerInput } from '@/components/ui/date-picker-input';

interface DateFilterInputProps {
  id: string;
  /** `YYYY-MM-DD`, the form both the URL and the API speak. */
  value: string | undefined;
  /** Given `undefined` when the field is cleared, so no filter is sent at all. */
  onChange: (value: string | undefined) => void;
  /** Latest date the reader may pick. Defaults to today. */
  max?: Date;
  /** Earliest date the reader may pick, used to stop "to" preceding "from". */
  min?: Date;
}

/**
 * One end of a filter's date range, as the shared picker.
 *
 * The picker speaks `Date`; filters, the URL and the API speak `YYYY-MM-DD`.
 * The conversion is here rather than at each of the six call sites across the
 * three admin lists, which is also the only place the day-shift question has to
 * be got right — `DatePickerInput` emits noon UTC, so `format` reads back the
 * day that was actually clicked in any timezone.
 */
export function DateFilterInput({ id, value, onChange, max, min }: DateFilterInputProps) {
  const endMonth = max ?? new Date();

  return (
    <DatePickerInput
      id={id}
      value={value ? new Date(value) : undefined}
      onChange={(date) => onChange(date ? format(date, 'yyyy-MM-dd') : undefined)}
      // These are historical records: a future date returns nothing, and a
      // reversed range returns nothing either. Both are ruled out in the
      // calendar rather than explained after the fact by an empty table.
      disabled={(date) => date > endMonth || (min ? date < min : false)}
      startMonth={min}
      endMonth={endMonth}
    />
  );
}
